// extracted by mini-css-extract-plugin
export var yellow = "Logo-module--yellow--1Heyp";
export var slate = "Logo-module--slate--GBNET";
export var white = "Logo-module--white--cGWLt";